<div
  class="flex w-full items-center gap-2 rounded-sm p-1.5"
  [class.hover:bg-bush-green-15]="attendee().isInMaximizer"
>
  <button
    class="button-reset button-focus flex items-center gap-2 min-w-0 flex-1"
    [class.hover:cursor-pointer]="attendee().isInMaximizer"
    (click)="onNavigate()"
  >
    <!-- Avatar -->
    @if (attendee().isInMaximizer) {
      <div
        class="avatar avatar-sm flex-shrink-0"
        [class]="attendee() | outlookAvatarClasses: userEmails()"
      >
        @if (isLead()) {
          <span
            class="fa-icons icon icon-solid icon-12 icon-user-magnifying-glass m-auto"
          ></span>
        } @else if (isCompany()) {
          <span
            class="fa-icons icon icon-regular icon-16 icon-building m-auto"
          ></span>
        } @else {
          <span>{{ attendee() | outlookAvatarLetters }}</span>
        }
      </div>
    } @else {
      <div
        class="bg-neutral-20 rounded-sm w-8 h-8 flex items-center justify-center"
      >
        <span class="fa-icons icon-solid icon-16 icon-user text-white"></span>
      </div>
    }

    <!-- Info -->
    <div class="flex flex-col min-w-0 flex-1">
      <p class="text-body truncate">{{ attendee().displayName }}</p>
      <p class="caption text-neutral-70 truncate">
        {{ attendee().emailAddress }}
      </p>
      @if (attendee().isInMaximizer) {
        <p class="caption text-neutral-70 truncate">
          @if (isTeamMember(attendee().emailAddress)) {
            {{ 'outlook.shared.labels.teamMember' | translate }} /
          }
          @if (isLead()) {
            {{ 'outlook.entries.lead' | translate }}
          } @else if (attendee().abentryType === EntryType.Individual) {
            {{ 'individual' | translateVertical }}
          } @else {
            {{ 'outlook.entries.' + attendee().abentryType | translate }}
          }
        </p>
      }
    </div>
  </button>

  <!-- Actions -->
  <div class="flex items-center gap-0.5 flex-shrink-0">
    @if (!attendee().isInMaximizer) {
      <div class="relative inline-flex">
        <kendo-dropdownbutton
          #addEntryButton
          [title]="'outlook.main.tooltip.add-entry' | translate"
          [data]="addEntryMenuItems()"
          themeColor="primary"
          fillMode="flat"
          iconClass="fa-icons icon-solid icon-16 icon-plus"
          [popupSettings]="{ appendTo: popupContainer() ?? viewContainerRef }"
          (itemClick)="onItemClick($event, attendee())"
          (open)="onAddEntryOpen()"
        >
          <ng-template kendoDropDownButtonItemTemplate let-dataItem>
            <div
              class="flex items-center gap-1 w-full"
              kendoTooltip
              [tooltipTemplate]="tooltipTemplate"
              position="top"
              [callout]="false"
              [showOn]="dataItem.disabled ? 'hover' : 'none'"
              [title]="
                'outlook.rights.defaultMessage'
                  | translate
                    : {
                        right: 'outlook.rights.create' | translate,
                        entry:
                          dataItem.id === EntryType.Individual
                            ? ('individuals' | translateVertical)
                            : (dataItem.title | translate),
                      }
              "
            >
              <span [class]="dataItem.icon" class="w-6"></span>
              <p>
                @if (dataItem.id === EntryType.Individual) {
                  {{
                    dataItem.text
                      | translate
                        : {
                            label: 'individual' | translateVertical,
                          }
                  }}
                } @else {
                  {{ dataItem.text | translate }}
                }
              </p>
            </div>
          </ng-template>
        </kendo-dropdownbutton>
      </div>
    }

    @if (attendee().isInMaximizer) {
      <kendo-dropdownbutton
        #actionButton
        [title]="'outlook.compose.actions' | translate"
        [data]="actionItems()"
        themeColor="tertiary"
        iconClass="fa-icons icon-ellipsis-vertical icon-16 px-1"
        [popupSettings]="{ appendTo: popupContainer() ?? viewContainerRef }"
        (open)="onActionOpen()"
      ></kendo-dropdownbutton>
    }
  </div>
</div>

<ng-template #tooltipTemplate let-anchor>
  <p class="caption text-center text-neutral-90 whitespace-nowrap">
    {{ anchor.nativeElement.getAttribute('data-title') }}
  </p>
</ng-template>
